import * as types from './types';

const INITIAL_STATE = {
  getIPs: {
    loading: false,
    data: null,
    errors: null,
  },
  getEnabled: {
    loading: false,
    data: null,
    errors: null,
  },
  setEnabled: {
    loading: false,
    data: null,
    errors: null,
  },
  postIP: {
    loading: false,
    data: null,
    errors: null,
  },
  getMyIP: {
    loading: false,
    data: null,
    errors: null,
  },
  postDeleteIP: {
    loading: false,
    data: null,
    errors: null,
  },
  getMyIPValid: {
    loading: false,
    data: null,
    errors: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.NETWORKFILTERING_GETIPS_LOADING: {
      const { getIPs } = state;
      return { ...state, getIPs: { ...getIPs, loading: action.payload } };
    }
    case types.NETWORKFILTERING_GETIPS_SUCCESS: {
      const { getIPs } = state;
      return { ...state, getIPs: { ...getIPs, data: action.payload } };
    }
    case types.NETWORKFILTERING_GETIPS_ERROR: {
      const { getIPs } = state;
      return { ...state, getIPs: { ...getIPs, errors: action.payload } };
    }

    case types.NETWORKFILTERING_GETENABLED_LOADING: {
      const { getEnabled } = state;
      return {
        ...state,
        getEnabled: { ...getEnabled, loading: action.payload },
      };
    }
    case types.NETWORKFILTERING_GETENABLED_SUCCESS: {
      const { getEnabled } = state;
      return { ...state, getEnabled: { ...getEnabled, data: action.payload } };
    }
    case types.NETWORKFILTERING_GETENABLED_ERROR: {
      const { getEnabled } = state;
      return {
        ...state,
        getEnabled: { ...getEnabled, errors: action.payload },
      };
    }

    case types.NETWORKFILTERING_SETENABLED_LOADING: {
      const { setEnabled } = state;
      return {
        ...state,
        setEnabled: { ...setEnabled, loading: action.payload },
      };
    }
    case types.NETWORKFILTERING_SETENABLED_SUCCESS: {
      const { setEnabled } = state;
      return { ...state, setEnabled: { ...setEnabled, data: action.payload } };
    }
    case types.NETWORKFILTERING_SETENABLED_ERROR: {
      const { setEnabled } = state;
      return {
        ...state,
        setEnabled: { ...setEnabled, errors: action.payload },
      };
    }

    case types.NETWORKFILTERING_POSTIP_LOADING: {
      const { postIP } = state;
      return { ...state, postIP: { ...postIP, loading: action.payload } };
    }
    case types.NETWORKFILTERING_POSTIP_SUCCESS: {
      const { postIP } = state;
      return { ...state, postIP: { ...postIP, data: action.payload } };
    }
    case types.NETWORKFILTERING_POSTIP_ERROR: {
      const { postIP } = state;
      return { ...state, postIP: { ...postIP, errors: action.payload } };
    }

    case types.NETWORKFILTERING_GETMYIP_LOADING: {
      const { getMyIP } = state;
      return { ...state, getMyIP: { ...getMyIP, loading: action.payload } };
    }
    case types.NETWORKFILTERING_GETMYIP_SUCCESS: {
      const { getMyIP } = state;
      return { ...state, getMyIP: { ...getMyIP, data: action.payload } };
    }
    case types.NETWORKFILTERING_GETMYIP_ERROR: {
      const { getMyIP } = state;
      return { ...state, getMyIP: { ...getMyIP, errors: action.payload } };
    }

    case types.NETWORKFILTERING_POSTDELETEIP_LOADING: {
      const { postDeleteIP } = state;
      return {
        ...state,
        postDeleteIP: { ...postDeleteIP, loading: action.payload },
      };
    }
    case types.NETWORKFILTERING_POSTDELETEIP_SUCCESS: {
      const { postDeleteIP } = state;
      return {
        ...state,
        postDeleteIP: { ...postDeleteIP, data: action.payload },
      };
    }
    case types.NETWORKFILTERING_POSTDELETEIP_ERROR: {
      const { postDeleteIP } = state;
      return {
        ...state,
        postDeleteIP: { ...postDeleteIP, errors: action.payload },
      };
    }

    case types.NETWORKFILTERING_GETMYIPVALID_LOADING: {
      const { getMyIPValid } = state;
      return {
        ...state,
        getMyIPValid: { ...getMyIPValid, loading: action.payload },
      };
    }
    case types.NETWORKFILTERING_GETMYIPVALID_SUCCESS: {
      const { getMyIPValid } = state;
      return {
        ...state,
        getMyIPValid: { ...getMyIPValid, data: action.payload },
      };
    }
    case types.NETWORKFILTERING_GETMYIPVALID_ERROR: {
      const { getMyIPValid } = state;
      return {
        ...state,
        getMyIPValid: { ...getMyIPValid, errors: action.payload },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/state/reducer.js